import { render, staticRenderFns } from "./VoiceClassEditForm.vue?vue&type=template&id=17883725&scoped=true&"
import script from "./VoiceClassEditForm.vue?vue&type=script&lang=ts&"
export * from "./VoiceClassEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./VoiceClassEditForm.vue?vue&type=style&index=0&id=17883725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17883725",
  null
  
)

export default component.exports